'use strict';

const deliveryUtils = require('./deliveryModal/deliveryUtils');

/**
 * Checks whether the current customer is authenticated.
 * @returns {boolean} True if customer is logged in.
 */
function isCustomerAuthenticated() {
    return $('.ua-customer-logged').length > 0 || $('#myaccount .user-message .user-name').length > 0;
}

/**
 * Updates the add-to-cart button text for both mobile and desktop spans.
 * Preserves the inner span elements to allow CSS media queries to handle responsiveness.
 *
 * @param {boolean} isRecurrent - Whether recurring purchase is active.
 */
function updateAddToCartButton(isRecurrent) {
    const $addToCartButton = $('.product-actions .add-to-cart, .product-actions .quick-buy-recurrent-product');
    if (!$addToCartButton.length) {
        return;
    }

    const recurrencyText = $addToCartButton.data('recurrency-text');
    const originalDesktopText = $addToCartButton.data('original-text-desktop');
    const originalMobileText = $addToCartButton.data('original-text-mobile');

    const mobileText = isRecurrent ? recurrencyText : originalMobileText;
    const desktopText = isRecurrent ? recurrencyText : originalDesktopText;

    const $mobileSpan = $addToCartButton.find('.add-to-cart-mobile');
    const $desktopSpan = $addToCartButton.find('.add-to-cart-desktop');

    if ($mobileSpan.length && $desktopSpan.length) {
        $mobileSpan.text(mobileText);
        $desktopSpan.text(desktopText);
    } else {
        $addToCartButton.html(
            '<span class="add-to-cart-mobile">' + mobileText + '</span>' +
            '<span class="add-to-cart-desktop">' + desktopText + '</span>'
        );
    }
}

/**
 * Resets the mobile recurring purchase label to its default prompt text.
 */
function resetRecurringPurchaseMobileLabel() {
    const recurringPurchaseLabel = $('.recurring-purchase-mobile-text span');
    if (recurringPurchaseLabel.length && recurringPurchaseLabel.data('select-text')) {
        recurringPurchaseLabel.html(recurringPurchaseLabel.data('select-text'));
    }
}

/**
 * Shows the mobile recurring purchase label only while the recurring purchase toggle is active.
 * @param {boolean} isVisible - Whether the label should be displayed.
 */
function setRecurringPurchaseMobileLabelVisibility(isVisible) {
    $('.recurring-purchase-mobile-label').toggleClass('d-none', !isVisible);
}

/**
 * Updates the mobile recurring purchase label based on selected frequency.
 * @param {jQuery} [$selectInput] - The select element.
 */
function updateRecurringPurchaseMobileLabel($selectInput) {
    const recurringPurchaseLabel = $('.recurring-purchase-mobile-text span');
    if (!recurringPurchaseLabel.length) {
        return;
    }

    const $select = $selectInput || $('.recurring-purchase .select-input');
    const value = $select.val();

    if (value) {
        const frequencyText = `${recurringPurchaseLabel.data('selected-text')} ${value}</b>`;
        recurringPurchaseLabel.html(frequencyText);
        $select.removeClass('is-invalid');
        $('.recurring-purchase .invalid-feedback').hide();
    } else {
        resetRecurringPurchaseMobileLabel();
    }
}

/**
 * Event handler for frequency selection dropdown change.
 */
function handleRecurringPurchaseSelection() {
    updateRecurringPurchaseMobileLabel($(this));
}

/**
 * Handles toggling the recurring purchase checkbox.
 */
function handleRecurringPurchaseToggle() {
    const $checkbox = $(this);
    const isChecked = $checkbox.prop('checked');
    const $frequencySelect = $('.recurring-purchase .select-container');
    const isCustomerLogged = isCustomerAuthenticated();
    const isMobile = $('.ua-mobile').length !== 0;

    if (isChecked) {
        if (isCustomerLogged) {
            $frequencySelect.removeClass('d-none');
            setRecurringPurchaseMobileLabelVisibility(true);
            updateAddToCartButton(true);
            updateRecurringPurchaseMobileLabel($frequencySelect.find('.select-input'));
        } else {
            $checkbox.prop('checked', false);
            updateAddToCartButton(false);
            $frequencySelect.addClass('d-none');
            setRecurringPurchaseMobileLabelVisibility(false);
            resetRecurringPurchaseMobileLabel();

            const component = 'loginModal';
            if (isMobile) {
                $(document).trigger('openBottomSheetRequest', { targetId: '#' + component });
            } else {
                $('#modal' + component).modal('show');
            }
        }
    } else {
        updateAddToCartButton(false);
        $frequencySelect.addClass('d-none');
        setRecurringPurchaseMobileLabelVisibility(false);
        $frequencySelect.find('.select-input').removeClass('is-invalid');
        $('.recurring-purchase .invalid-feedback').hide();
        resetRecurringPurchaseMobileLabel();
    }
}

/**
 * Synchronizes recurring purchase UI elements (toggle, button, selector, mobile label)
 * with the current state of the checkbox and fulfillment method.
 */
function syncRecurringPurchaseUI() {
    const $recurringPurchase = $('.recurring-purchase');
    if (!$recurringPurchase.length) {
        return;
    }

    const $checkbox = $recurringPurchase.find('.recurring-purchase-checkbox');
    const $frequencySelect = $recurringPurchase.find('.select-container');
    const ffData = $('.delivery-data').data('fulfillment');

    // If locker is selected, recurrence is incompatible
    if (deliveryUtils.hasShippingMethod() && ffData && ffData.isShippingMethodLocker) {
        $checkbox.prop('checked', false);
        $frequencySelect.addClass('d-none');
        setRecurringPurchaseMobileLabelVisibility(false);
        updateAddToCartButton(false);
        resetRecurringPurchaseMobileLabel();
        return;
    }

    const isChecked = $checkbox.prop('checked');
    const isCustomerLogged = isCustomerAuthenticated();

    if (isChecked && isCustomerLogged) {
        $frequencySelect.removeClass('d-none');
        setRecurringPurchaseMobileLabelVisibility(true);
        updateAddToCartButton(true);
        updateRecurringPurchaseMobileLabel($frequencySelect.find('.select-input'));
    } else if (isChecked && !isCustomerLogged) {
        $checkbox.prop('checked', false);
        $frequencySelect.addClass('d-none');
        setRecurringPurchaseMobileLabelVisibility(false);
        updateAddToCartButton(false);
        resetRecurringPurchaseMobileLabel();
    } else {
        $frequencySelect.addClass('d-none');
        setRecurringPurchaseMobileLabelVisibility(false);
        updateAddToCartButton(false);
        resetRecurringPurchaseMobileLabel();
    }
}

/**
 * Updates the display based on the selected delivery method (shipping or locker).
 * Hides/shows elements in PDP accordingly and logs a message if no valid method is selected.
 */
function manageIncompatibleDeliveryMethodUI() {
    var recurringPurchaseSection = $('.recurring-purchase');
    var ffData = $('.delivery-data').data('fulfillment');

    // If no fulfillment data or incompatible delivery method, exit early
    if (!deliveryUtils.hasShippingMethod()) {
        return;
    }
    handleToggleAndUpdateUrlForRecurringDelivery(ffData);
    var $togglePurchase = recurringPurchaseSection.find('.toggle-purchase');
    var $incompMsg = recurringPurchaseSection.find('.recurring-incompatibility-message');

    // Set up click event handler for opening delivery modal
    $('.recurring-purchase-open-delivery-modal').off('click').on('click', function (event) {
        event.preventDefault();
        $(document).trigger('openDeliveryModalRequest', { redirectUrl: '' });
    });

    // Hide or show elements based on the selected method
    if (ffData.isShippingMethodLocker) {
        $togglePurchase.hide();
        $incompMsg.show();
        recurringPurchaseSection.find('.recurring-purchase-checkbox').prop('checked', false);
        recurringPurchaseSection.find('.select-container').addClass('d-none');
        setRecurringPurchaseMobileLabelVisibility(false);
        updateAddToCartButton(false);
        resetRecurringPurchaseMobileLabel();
    } else if (ffData.isShippingMethodDelivery) {
        $togglePurchase.show();
        $incompMsg.hide();
    }
}

/**
 * Handles toggling the recurring delivery option based on shipping method.
 * @param {Object} ffData - An object containing shipping information.
 * Checks if 'selectRecurrentToggle' exists in the URL parameters and enables the recurring purchase checkbox.
 * Removes 'selectRecurrentToggle' from the URL using replaceState without reloading the page.
 */
function handleToggleAndUpdateUrlForRecurringDelivery(ffData) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    if (!params.has('selectRecurrentToggle')) {
        return;
    }

    if (ffData.isShippingMethodDelivery && params.get('selectRecurrentToggle')) {
        $('.recurring-purchase-checkbox').prop('checked', true).trigger('change');
    }

    params.delete('selectRecurrentToggle');

    // Replaces the current history entry instead of adding one: extra entries of the same PDP keep older
    // toggle states that the browser restores when going back
    const newUrl = (params.toString() ? `${url.pathname}?${params}` : url.pathname) + url.hash;
    window.history.replaceState(window.history.state, '', newUrl);
}

/**
 * Initializes event listeners for recurring purchase interactions on PDP.
 */
function startRecurringPurchaseEvents() {
    $('body').off('change', '.recurring-purchase-checkbox').on('change', '.recurring-purchase-checkbox', handleRecurringPurchaseToggle);
    $('.recurring-purchase .select-input').off('change').on('change', handleRecurringPurchaseSelection);
    manageIncompatibleDeliveryMethodUI();
    syncRecurringPurchaseUI();

    $(window).off('pageshow.recurringPurchase').on('pageshow.recurringPurchase', function () {
        syncRecurringPurchaseUI();
    });
}

/**
 * Binds click handler to quick-buy-recurrent-product button.
 * @param {Object} base - Base helper containing createTemporaryBasket.
 */
function handleRecurringPurchaseButtonClicked(base) {
    $('body').on('click', '.quick-buy-recurrent-product', function (e) {
        e.preventDefault();
        e.stopPropagation();
        base.createTemporaryBasket($(this));
    });
}

/**
 * Switches the button class between add-to-cart and quick-buy-recurrent-product.
 * @param {jQuery} $buttonTextElement - Element within the button.
 * @param {boolean} recurrency - Whether recurrence is active.
 */
function useAsRecurrencePurchaseTrigger($buttonTextElement, recurrency) {
    if (recurrency && $buttonTextElement) {
        $buttonTextElement
            .closest('button')
            .addClass('quick-buy-recurrent-product');
        $buttonTextElement.closest('button').removeClass('add-to-cart');
    } else if ($buttonTextElement) {
        $buttonTextElement
            .closest('button')
            .removeClass('quick-buy-recurrent-product');
        $buttonTextElement.closest('button').addClass('add-to-cart');
    }
}

/**
 * Gets the PDP recurring purchase state, ignoring the quick view one, so FulfillmentMethod-SetDelivery
 * can keep it in session and Product-Details can render it again after the page reloads.
 *
 * @returns {Object} recurringPurchasePid and recurringPurchaseFrequency request fields, empty when the toggle is off
 */
function getRecurringPurchaseState() {
    const $checkbox = $('.recurring-purchase-checkbox:checked').filter(function () {
        return $(this).closest('.product-quickview').length === 0;
    });

    if (!$checkbox.length) {
        return {};
    }

    return {
        recurringPurchasePid: $checkbox.closest('.product-detail').attr('data-pid') || '',
        recurringPurchaseFrequency: $checkbox.closest('.recurring-purchase').find('.select-input').val() || ''
    };
}

module.exports = {
    startRecurringPurchaseEvents,
    manageIncompatibleDeliveryMethodUI,
    handleRecurringPurchaseButtonClicked,
    useAsRecurrencePurchaseTrigger,
    getRecurringPurchaseState
};
